import { Action, createReducer, on } from '@ngrx/store';

import * as CommonIdFindUniversitiesActions from '../../actions/common-id/common-id-find-universities.actions';
import * as CommonIdGetDesiredUniversitiesActions from '../../actions/common-id/common-id-get-desired-universities.actions';
import { CommonIdFindUniversitiesResponse } from 'src/app/models/common-id/common-id-find-universities-response';
import { AppError } from 'src/app/errors/app-error';

export interface CommonIdFindUniversitiesResult {
  success: boolean;
  response: CommonIdFindUniversitiesResponse[] | null;
  error: AppError | null;
}

export const commonIdFindUniversitiesFeatureKey = 'commonIdFindUniversities';

export interface State {
  result: CommonIdFindUniversitiesResult | null;
}

export const initialState: State = {
  result: null
};

const commonIdFindUniversitiesReducer = createReducer(
  initialState,

  /* 登録されている志望校の取得 */
  on(CommonIdFindUniversitiesActions.commonIdFindUniversitiesSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      result: { success: true, response, error: null }
    };
    return next;
  }),
  on(CommonIdFindUniversitiesActions.commonIdFindUniversitiesFailure, (state, { error }) => {
    const next: State = {
      ...state,
      result: { success: false, response: null, error }
    };
    return next;
  }),
  on(CommonIdFindUniversitiesActions.initializeCommonIdFindUniversitiesResult, state => {
    const next: State = { ...state, result: null };
    return next;
  }),

  /* 最新の志望校の取得 */
  on(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      result: { ...state.result, response: response.universities }
    };
    return next;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return commonIdFindUniversitiesReducer(state, action);
}
